module.exports = __webpack_public_path__ + "d83cc338580a410ba370d029b571fa1f.svg";